import { LayoutAlign, LayoutFlexDirection, LayoutJustify } from '@philips-internal/oswald-ui-constants';
import { any, arrayOf, bool, node, oneOf, oneOfType, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { enumValues } from '@philips-internal/oswald-ui-utils';
const PanelProperties = {
    alignItems: {
        type: oneOf(enumValues(LayoutAlign)).group('alignment'),
    },
    background: {
        type: string,
    },
    border: {
        type: string.group('borders'),
    },
    borderRadius: {
        type: oneOf(['', '0px', '8px', '16px', '24px', '32px']).group('borders'),
    },
    boxShadow: {
        type: string,
    },
    children: {
        type: oneOfType([node, arrayOf(node)]).notEnumerable(),
    },
    className: {
        type: string,
    },
    data: {
        type: any.notEnumerable(),
    },
    flexDirection: {
        type: oneOf(enumValues(LayoutFlexDirection)),
    },
    gap: {
        type: string,
    },
    gridArea: {
        type: string.notEnumerable(),
    },
    height: {
        type: string,
    },
    justifyContent: {
        type: oneOf(enumValues(LayoutJustify)).group('alignment'),
    },
    lightTheme: {
        defaultValue: false,
        type: bool.group('theme'),
    },
    margin: {
        type: string.group('spacing'),
    },
    padding: {
        type: string.group('spacing'),
    },
    uuid: {
        defaultValue: '',
        type: string.notEnumerable(),
    },
    visible: {
        defaultValue: true,
        type: bool,
    },
};
export { PanelProperties, };
//# sourceMappingURL=panel-types.js.map